export enum PaymentProviderType {
    wePay = 1
}
